import { FunctionalComponent, h } from "@stencil/core";
import { TableRowWithId } from "../table-interfaces";
import { SortDirection } from "../table-types";

interface TableHeaderProps {
    group?: boolean;
    sortable?: boolean;
    field?: string;
    label?: string;
    sortField?: string;
    testId?: string;
    initialSortDirection: SortDirection;
    filterable?: boolean;
    filterEmptyAndDuplicateItems?: boolean;
    filterItems?: [];
    customComparator?: (a: TableRowWithId, b: TableRowWithId) => number;
    customFilterCallback?: (filteredData: TableRowWithId[], selectedItems: []) => TableRowWithId[];
}

const tableClass = "uic-table";
export const TableHeader: FunctionalComponent<TableHeaderProps> = (
    {
        group = false,
        sortable = false,
        label = "",
        sortField = "",
        field = undefined,
        testId = null,
        initialSortDirection = "",
        filterable = false,
        filterItems = [],
        filterEmptyAndDuplicateItems: filterEmptyAndDuplicateItems = false,
        customComparator,
        customFilterCallback
    },
    children
) => {
    const testIdValue = testId == null ? null : `${tableClass}__th-${testId}`;
    return (
        <th
            class={{
                [`${tableClass}__th`]: true,
                [`${tableClass}__th--group`]: group
            }}
            data-testid={testIdValue}
            scope='row'
        >
            <div class='uic-table-th'>
                {sortable && label !== "" && (
                    <uic-table-head-sort
                        sortField={sortField !== "" ? sortField : null}
                        sortedDirection={initialSortDirection}
                        customComparator={customComparator}
                    ></uic-table-head-sort>
                )}
                {label}
                {filterable && label !== "" && (
                    <uic-table-head-filter
                        filterItems={filterItems}
                        field={field}
                        customFilterCallback={customFilterCallback}
                        filterEmptyAndDuplicateItems={filterEmptyAndDuplicateItems}
                    />
                )}
                {children}
            </div>
        </th>
    );
};
